import React, {Component} from 'react';
import Request from './request';
import Main from './main/Main';
import Topbar from './topbar/Topbar';
import About from './about/About';
import Sale from './sale/Sale';
import Repair from './repair/Repair';
import Education from './education/Education';
import Services from './services/Services';
import Category from './category/Category';
import Product from './product/Product';
import Contact from './contact/Contact';
import jump from 'jump.js';
import {TOKEN, URL} from "./constants";

class App extends Component {
    state = {
        brand_id: 1,
        category_id: 1,
        itemPerPage: 3,
        serviceItemsPerPage: 4,
        brand: {},
        category: {},
        pageList: [],
        lang: "tr",
        menuBackgroundChange: false,
        currentPage: 0,
        isMobile: false,
        pageData: {},
    };
    componentWillMount() {
        fetch(URL + "social", {
            headers: {"Authorization": "Bearer " + TOKEN}
        })
            .then(response => response.json())
            .then(response => {
                if (response.status === "error") {
                    console.log(response.data);
                    return false;
                }
                //console.log(response.data);
                this.setState({pageData: response.data});
                //console.log(this.state.pageData);
                document.title = this.state.pageData.title;
            })
            .catch(reason => console.log(reason));
        const lang = localStorage.getItem("lang");
        //console.log("Current Lang", lang);
        try{
            document.createEvent("TouchEvent");
            let update = {isMobile: true, itemPerPage: 1, serviceItemsPerPage: 1};
            if(lang === null){  update.lang = "tr"; localStorage.setItem("lang", "tr"); }
            else{ update.lang = lang; }
            this.setState(update); //console.log("Display Mode: Mobile");
        }
        catch(e){
            let update = {};
            if(lang === null){  update.lang = "tr"; localStorage.setItem("lang", "tr"); }
            else{ update.lang = lang; }
            this.setState(update);
            //console.log("Display Mode: Desktop");
        }
        this.getBrandDetail();
        this.getPages();
    }
    componentDidMount(){
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = (event) => {
        let update = {};
        if(window.scrollY>50){
            if(this.state.menuBackgroundChange === false)
                update.menuBackgroundChange = true;
        }else{
            if(this.state.menuBackgroundChange === true)
                update.menuBackgroundChange = false;
        }

        const mainOffset = document.getElementsByClassName("main")[0].offsetTop;
        const aboutOffset = document.getElementsByClassName("about")[0].offsetTop;
        const saleOffset = document.getElementsByClassName("sale")[0].offsetTop;
        const educationOffset = document.getElementsByClassName("education")[0].offsetTop;
        const repairOffset = document.getElementsByClassName("repair")[0].offsetTop;
        const categoryOffset = document.getElementsByClassName("category")[0].offsetTop;
        const productOffset = document.getElementsByClassName("product")[0].offsetTop;
        const servicesOffset = document.getElementsByClassName("services")[0].offsetTop;
        const contactOffset = document.getElementsByClassName("contact")[0].offsetTop;

        let currentPage = 0;
        if(window.scrollY >= mainOffset){ currentPage=0; }
        if(window.scrollY >= aboutOffset -100 ){ currentPage=1; }
        if(window.scrollY >= saleOffset -150 ){ currentPage=2;  }
        if(window.scrollY >= educationOffset -100 ){ currentPage=3; }
        if(window.scrollY >= repairOffset -100 ){ currentPage=4; }
        if(window.scrollY >= categoryOffset -100 ){ currentPage=5; }
        if(window.scrollY >= productOffset -100 ){ currentPage=6; }
        if(window.scrollY >= servicesOffset -100 ){ currentPage=7; }
        if(window.scrollY >= contactOffset -100 ){ currentPage=8; }
        //console.log(window.scrollY, aboutOffset);
        if(currentPage !== this.state.currentPage){
            update.currentPage = currentPage;
        }

        //console.log("update", update);

        if(Object.keys(update).length > 0){
            this.setState(update);
        }
        //console.log(currentPage);
        //console.log(window.scrollY);
    };
    getPages() {
        Request.get("page_allWithContent")
            .then(response => {
                if (response.status === "error") {
                    console.log(response.data);
                    return false;
                }
                this.setState({pageList: response.data})
            }).catch(reason => console.log(reason));
        /*
        fetch(URL + "page_allWithContent", {
            headers: {"Authorization": "Bearer " + TOKEN}
        }).then(response => response.json())
            .then(response => {
                if (response.status === "error") {
                    console.log(response.data);
                    return false;
                }
                this.setState({pageList: response.data})
            }).catch(reason => console.log(reason));
         */
    }

    selectLang(lang){
        localStorage.setItem("lang", lang);
        this.setState({lang});
    }

    selectBrand(brand_id) {
        if(brand_id === this.state.brand_id) return false;
        if(brand_id === "3"){ // AVK
            Request.get("brand/3").then(response=>{
                if(response.status === "error"){ console.log(console.data); return false}
               this.setState({
                   category_id: 8,
                   brand_id: 3,
                   brand: response.data
               }, () => jump(".product"));
            });
        }else
            this.setState({brand_id}, () => this.getBrandDetail());
    }

    selectCategory(category) {
        this.setState({category_id: category.category_id, category});
        jump(".product");
    }

    getBrandDetail() {
        Request.post("category_allWithParentDetail", {operation_id:this.state.brand_id})
            .then(response => {
                if (response.status === "error") {console.log(response.data); return false;}
                this.setState({
                    brand: response.data.brand,
                    category_id: response.data.categoryList[0].category_id,
                    category: response.data.categoryList[0]
                });
            })
            .catch(reason => console.log(reason));
        /*
        fetch(URL + "category_allWithParentDetail", {
            mode: "cors",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + TOKEN
            },
            body: JSON.stringify({operation_id:this.state.brand_id})
        })
            .then(response => response.json())
            .then(response => {
                if (response.status === "error") {
                    console.log(response.data);
                    return false;
                }
                this.setState({
                    brand: response.data.brand,
                    category_id: response.data.categoryList[0].category_id
                });
            })
            .catch(reason => console.log(reason));

         */
        return true;
    }
    render() {
        const appClass = this.state.isMobile?"App Mobile": "App";
        return (
            <div className={appClass}>
                <Topbar lang={this.state.lang}
                        currentPage={this.state.currentPage}
                        menuBackgroundChange={this.state.menuBackgroundChange}
                        selectLang={this.selectLang.bind(this)}
                        selectBrand={this.selectBrand.bind(this)}/>
                <Main lang={this.state.lang} isMobile={this.state.isMobile} />
                {
                    this.state.pageList.length > 0 &&
                    <>
                        <About lang={this.state.lang}  pageData={this.state.pageList[0]}/>
                        <Sale lang={this.state.lang}  pageData={this.state.pageList[1]}/>
                        <Repair lang={this.state.lang}  pageData={this.state.pageList[2]}/>
                        <Education lang={this.state.lang}  pageData={this.state.pageList[3]}/>
                    </>
                }
                {
                    Object.keys(this.state.brand).length > 0 &&
                    <>
                        <Category lang={this.state.lang}
                                  itemPerPage={this.state.itemPerPage}
                                  brand={this.state.brand}
                                  brand_id={this.state.brand_id}
                                  selectCategory={this.selectCategory.bind(this)}/>
                        <Product lang={this.state.lang}
                                 itemPerPage={this.state.itemPerPage}
                                 brand={this.state.brand}
                                 category={this.state.category}
                                 category_id={this.state.category_id}/>
                    </>
                }
                {
                    this.state.pageList.length > 0 &&
                    <Services lang={this.state.lang} serviceItemsPerPage={this.state.serviceItemsPerPage}  pageData={[
                        this.state.pageList[4],
                        this.state.pageList[5],
                        this.state.pageList[6],
                        this.state.pageList[7]
                    ]}/>
                }
                <Contact lang={this.state.lang}  />
            </div>
        );
    }
}


export default App;
